export default "__VITE_ASSET__D0O_MzZA__"